"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPractice = void 0;
const isPractice = (currentSubTask) => {
    if (currentSubTask === 'practice_response') {
        return true;
    }
    return false;
};
exports.isPractice = isPractice;
